import { Injectable } from "@angular/core";
import { DefaultSelection36BoroughPayload } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalBoroughService extends BaseService<DefaultSelection36BoroughPayload> {}
